// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uc4V7XLbQpMqJTynB6M3{z-index:var(--zIndex-BASE_11);background-color:var(--black-30);width:100%;height:100%;position:fixed}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentOverlay": `uc4V7XLbQpMqJTynB6M3`
};
export default ___CSS_LOADER_EXPORT___;
